<template>
  <!-- Table List -->
  <v-list
    class="py-0"
  >
    <v-list-item-group
      :value="selected"
      active-class="primary--text"
      @change="selectedChange"
    >
      <template v-for="[slot, reservationsForSlot] in reservationsByTime.entries()">
        <guest-list-header-row
          :key="slot"
          :title="localized.hourMinTextFrom24hr(slot) || ''"
          :incoming="guestCountsByTime.get(slot)?.incoming"
          :seated="guestCountsByTime.get(slot)?.seated"
        />
        <div
          :key="`grp-${slot}`"
          class="gp-guest-list-group"
        >
          <template v-for="(reservation, i) in reservationsForSlot">
            <guest-list-row
              :key="reservation.id"
              class="gp-guest-list"
              :reservation="reservation"
              :waitlist-list-order="waitingListOrderForReservation.get(reservation.id)"
              :overbooked-tab-items="overbookedTabItemsForReservation.get(reservation.id)"
              unread-reservations
              :compact="vuetify.breakpoint.xsOnly"
            />
            <v-divider
              :key="`${slot}_${i}`"
            />
          </template>
        </div>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script lang="ts" setup>
import {
  computed, onMounted, PropType, ref, toRef, watch,
} from 'vue';
import { useRouter } from 'vue-router/composables';
import Reservation from '@/model/Reservation';
import { tryEditReservation, tryCloseEditReservation } from '@/services/reservation-edit-utils';
import useGuestCountsByTime from '@/composables/guest-counts-by-time';
import { useLocalized, useVuetify } from '@/components/helpers/vue2-helpers';
import store from '@/store/store';
import GuestListRow from './GuestListRow.vue';
import GuestListHeaderRow from './GuestListHeaderRow.vue';

const props = defineProps({
  reservationsByTime: { type: Map as PropType<Map<string, Reservation[]>>, required: true },
});

const router = useRouter();
const localized = useLocalized();
const vuetify = useVuetify();

const selected = ref<number | undefined>(undefined);

const edited = computed(() => store.getters.editReservation?.id as number | undefined);
const waitingListOrderForReservation = computed(
  () => store.getters.orderForWaitingReservation as Map<number, number>,
);
const overbookedTabItemsForReservation = computed(
  () => store.getters.dayOverbookedTabItemsForReservationId as Map<number, Set<number> | undefined>,
);

const { guestCountsByTime } = useGuestCountsByTime(toRef(props, 'reservationsByTime'));

watch(edited, (id) => { selected.value = id; });

onMounted(() => {
  selected.value = store.getters.editReservation?.id;
});

const selectedChange = async (reservationId: number | undefined) => {
  selected.value = reservationId;

  const { reservationsById } = store.state.reservations;
  const reservation = reservationId ? reservationsById[reservationId] : undefined;
  if (reservation === undefined) await tryCloseEditReservation();
  else await tryEditReservation(router, reservation);
};

</script>

<style lang="scss">

  .gp-guest-list-group div.gp-guest-list:nth-of-type(even)  {
    background-color: $grey-2-color;
    .theme--dark & {
      background-color: $grey-90-color;
    }
  }

</style>
